import React from 'react';
import { Box, Container, Typography } from '@mui/material';

const LoginPage: React.FC = () => {
  return (
    <Container maxWidth="sm" sx={{ py: 4 }}>
      <Typography variant="h4" gutterBottom>
        Login
      </Typography>
      <Typography variant="body1" color="text.secondary">
        Login page coming soon...
      </Typography>
    </Container>
  );
};

export default LoginPage;
